import groundfloor_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/GroundFloor/gro_flo_acc_egr.png";
import groundfloor_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/GroundFloor/gro_flo_fir_gro.png";

import groundfloor_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/GroundFloor/gro_flo_hou.png";
import groundfloor_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/GroundFloor/gro_flo_reb.png";
import groundfloor_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/GroundFloor/gro_flo_sca.png";
import groundfloor_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/GroundFloor/gro_flo_sit_spe_met.png";
import groundfloor_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/GroundFloor/gro_flo_tre.png";
import groundfloor_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/GroundFloor/gro_flo_wor_rou.png";

import supervision_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Supervision/sup_can.png";
import supervision_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Supervision/sup_com_ind.png";
import supervision_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Supervision/sup_csc.png";
import supervision_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Supervision/sup_dri_wat.png";
import supervision_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Supervision/sup_dry_cha.png";
import supervision_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Supervision/sup_fir_aid.png";

import supervision_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Supervision/sup_pla_equ.png";
import supervision_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Supervision/sup_ppe.png";
import supervision_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Supervision/sup_saf_pas.png";
import supervision_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Supervision/sup_sit_spe_met.png";
import supervision_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Supervision/sup_smo_con.png";
import supervision_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Supervision/sup_wc_was.png";

import ppe_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_dus_mas.png";
import ppe_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_ear_pro.png";
import ppe_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_eye_pro.png";
import ppe_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_fac_pro.png";
import ppe_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_hi_vis.png";
import ppe_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_kne_pad.png";
import ppe_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_per_flo_dev.png";
import ppe_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_rad_con_ala.png";
import ppe_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_res_equ.png";
import ppe_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_saf_boo.png";
import ppe_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_saf_glo.png";
import ppe_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_saf_har.png";
import ppe_14 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_saf_hel.png";
import ppe_15 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PPE/ppe_saf_ove.png";

import traffic_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_2_way_tra.png";
import traffic_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_15_min.png";
import traffic_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_add_sig.png";
import traffic_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_all_sto.png";
import traffic_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_giv_tak.png";
import traffic_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_hi_vis_tru.png";
import traffic_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_imp_pro_veh.png";
import traffic_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_lia_per.png";
import traffic_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_lig.png";
import traffic_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_mob_roa.png";
import traffic_14 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_par.png";
import traffic_15 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_pri.png";
import traffic_16 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_sem_sta.png";
import traffic_17 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_sit_spe_met.png";
import traffic_18 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_spe_con_con.png";
import traffic_19 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_sta_pla.png";
import traffic_20 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_sto_and_go.png";
import traffic_21 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_tra_sig.png";
import traffic_22 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_veh_res_sys.png";
import traffic_23 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Traffic/tra_vis.png";

import WCTP_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToPublic/wcp_acc_pre.png";
import WCTP_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToPublic/wcp_bar_fen_hoa.png";
import WCTP_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToPublic/wcp_cyc_lan.png";
import WCTP_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToPublic/wcp_dus_muc_cle.png";
import WCTP_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToPublic/wcp_han_con.png";
import WCTP_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToPublic/wcp_hou.png";
import WCTP_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToPublic/wcp_ped_con.png";
import WCTP_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToPublic/wcp_ped_rou.png";
import WCTP_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToPublic/wcp_pub_tra_poi.png";
import WCTP_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToPublic/wcp_sec.png";
import WCTP_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToPublic/wcp_sit_spe_met.png";
import WCTP_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToPublic/wcp_vis_con.png";

import cov_1st_aid from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_1st_aid.png";
import cov_can_arr from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_can_arr.png";
import cov_cov_ppe from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_cov_ppe.png";
import cov_del from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_del.png";
import cov_eat_on_sit from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_eat_on_sit.png";
import cov_bys from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_bys.png"
import cov_mee from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_mee.png";
import cov_per_hyg from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_per_hyg.png";
import cov_phy_dis from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_phy_dis.png";
import cov_sig from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_sig.png";
import cov_too_equ_sur from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_too_equ_sur.png";
import cov_veh from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_veh.png";
import cov_wel_arr from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_wel_arr.png";
import cov_wor_org from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Covid/cov_wor_org.png";

import HTHL_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_cab_che.png";
import HTHL_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_cab_pro.png";
import HTHL_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_car_too.png";
import HTHL_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_cha_saw_ppe.png";
import HTHL_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_com_whi_che.png";
import HTHL_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_con_saw.png";
import HTHL_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_dus_sup.png";
import HTHL_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_fla_cut.png";
import HTHL_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_gar.png";
import HTHL_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_gas_fla_arr.png";
import HTHL_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_gen_out.png";
import HTHL_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_jac_ham_vib.png";
import HTHL_14 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_mai.png";
import HTHL_15 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_pai_spr.png";
import HTHL_16 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_per_work.png";
import HTHL_17 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_pow_flo.png";
import HTHL_18 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_rep_dam_par.png";
import HTHL_19 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_san.png";
import HTHL_20 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_sel_sui.png";
import HTHL_21 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_sit_spe_met.png";
import HTHL_22 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HandTools/han_vol.png";

import EHL_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_exa_ins.png";
import EHL_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_fir_gro.png";
import EHL_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_env_ris_ass.png";
import EHL_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_no_und.png";
import EHL_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_bac_fil.png";
import EHL_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_bat_bac.png";
import EHL_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_pro.png";
import EHL_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_sho.png";
import EHL_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_tre_box.png";
import EHL_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_she_pil.png";
import EHL_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_gro_fra_sec.png";
import EHL_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_und.png";
import EHL_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_bar_fen_hoa.png";
import EHL_14 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_cov.png";
import EHL_15 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_spo_bac.png";
import EHL_16 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_exc_zon.png";
import EHL_17 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_cho.png";
import EHL_18 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_lad_acc.png";
import EHL_19 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_saf_sta.png";
import EHL_20 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_pum.png";
import EHL_21 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_lig.png";
import EHL_22 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_per_wor.png";
import EHL_23 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Excavation/exc_sit_spe_met.png";

import Dust_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Dust/dus_ven.png";
import Dust_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Dust/dus_wet.png";
import Dust_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Dust/dus_ext.png";
import Dust_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Dust/dus_sit_spe_met.png";

import Infestation_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Infestation/inf_sur.png";
import Infestation_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Infestation/inf_wei_dis.png";
import Infestation_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Infestation/inf_dec_ext.png";
import Infestation_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Infestation/inf_spe_ppe.png";
import Infestation_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Infestation/inf_spe_sit_spe_met.png";

import fire_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Fire/fir_ext_dry_pow.png";
import fire_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Fire/fir_ext_wat.png";
import fire_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Fire/fir_ext_foa.png";
import fire_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Fire/fir_ext_car_dio.png";
import fire_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Fire/fir_eme_rou.png";
import fire_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Fire/fir_sit_spe_met.png";

import Rock from "../../pages/MasterSSWPFormCreate/img/sswpIcons/RockBlast/roc_bla_sit_spe_met.png";

import HGHL_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HarmfulGases/ham_gas_sur.png";
import HGHL_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HarmfulGases/ham_gas_ven.png";
import HGHL_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HarmfulGases/ham_gas_per_wor.png";
import HGHL_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HarmfulGases/ham_gas_sit_spe_met.png";

import Steel_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SteelWorks/ste_wor_acc.png";
import Steel_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SteelWorks/ste_wor_fal_and_arr.png";
import Steel_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SteelWorks/ste_wor_saf_lin.png";
import Steel_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SteelWorks/ste_wor_net_bea_bag.png";

import PHL_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PreCastWorks/pre_cast_del_tra.png";
import PHL_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PreCastWorks/pre_cast_anc_clu.png";
import PHL_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PreCastWorks/pre_cast_spr_bea.png";
import PHL_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PreCastWorks/pre_cast_pac_pie.png";
import PHL_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PreCastWorks/pre_cast_tag_lin.png";
import PHL_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PreCastWorks/pre_cast_exc_zon.png";
import PHL_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PreCastWorks/pre_cast_works_fixing_and_anchors.jpg";
import PHL_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PreCastWorks/pre_cast_sla_bea.png";
import PHL_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PreCastWorks/pre_cast_pro_typ.png";
import PHL_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PreCastWorks/pre_cast_sit_spe_met.png";

import IHL_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/InSiteWorks/insitu_gua_all_ope.png";
import IHL_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/InSiteWorks/insitu_pro_sup.png";
import IHL_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/InSiteWorks/insitu_pro_edg_pro.png";
import IHL_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/InSiteWorks/insitu_pro_wor_pla.png";
import IHL_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/InSiteWorks/insitu_tem_wor.png";
import IHL_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/InSiteWorks/insitu_for_tab.png";
import IHL_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/InSiteWorks/insitu_con_pok.png";
import IHL_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/InSiteWorks/insitu_reb.png";
import IHL_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/InSiteWorks/insitu_ste_fix.png";
import IHL_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/InSiteWorks/insitu_con_pou.png";
import IHL_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/InSiteWorks/insitu_str.png";
import IHL_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/InSiteWorks/insitu_sit_spe_met.png";

import UFHL_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_acc_rou.png";
import UFHL_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_hou.png";
import UFHL_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_wor_foo.png";
import UFHL_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_lad_acc.png";
import UFHL_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_saf_lad.png";
import UFHL_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_tie_lad.png";
import UFHL_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_sca.png";
import UFHL_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_edg_pro.png";
import UFHL_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_wor_pla.png";
import UFHL_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_sta_pro.png";
import UFHL_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_joi_dec.png";
import UFHL_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_oh_wor.png";
import UFHL_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_fal_arr.png";
import UFHL_14 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_blo_cou.png";
import UFHL_15 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_exc_zon.png";
import UFHL_16 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_lig.png";
import UFHL_17 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_pro.png";
import UFHL_18 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_loa_bay.png";
import UFHL_19 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_anc_clu.png";
import UFHL_20 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_sla_eye.png";
import UFHL_21 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_sla_anc.png";
import UFHL_22 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/UpperFloor/upp_flo_sit_spe_met.png";

import Roof_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_wea.png";
import Roof_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_war_sig.png";
import Roof_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_a_lad.png";
import Roof_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_roo_lad.png";
import Roof_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_edg_pro.png";
import Roof_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_gua_all_ope.png";
import Roof_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_mew.png";
import Roof_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_dec_tru.png";
import Roof_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_net_bea_bag.png";
import Roof_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_oh_lin.png";
import Roof_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_saf_sto.png";
import Roof_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_sti.png";
import Roof_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Roof/roo_wor_sit_spe_met.png";

import HAHL_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HealthAssess/hea_ass_hea_eff.png";
import HAHL_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HealthAssess/hea_har_gas_dus.png";
import HAHL_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HealthAssess/hea_bio_age.png";
import HAHL_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HealthAssess/hea_syr.png";
import HAHL_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HealthAssess/hea_mon_sur.png";
import HAHL_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HealthAssess/hea_vac.png";
import HAHL_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HealthAssess/hea_dec_uni.png";
import HAHL_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/HealthAssess/hea_sit_spe_met.png";

import MHHL_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ManualHandling/man_han_tra.png";
import MHHL_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ManualHandling/man_han_ris_ass.png";
import MHHL_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ManualHandling/man_han_wor_org.png";
import MHHL_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ManualHandling/man_han_saf_foo.png";
import MHHL_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ManualHandling/man_han_mec_aid.png";
import MHHL_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ManualHandling/man_han_mul_per.png";
import MHHL_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ManualHandling/man_han_sit_spe_met.png";

import General_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_oth_wea.png";
import General_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_oth_hou.png";
import General_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_oth_san.png";
import General_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_war_sig.png";
import General_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_dra_str_str.png";
import General_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_emg_pro.png";
import General_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_fir_con_ass.png";
import General_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_fir_gro.png";
import General_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_bio_bur_tra.png";
import General_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_ani_det.png";
import General_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_saf_sto.png";
import General_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_was_man.png";
import General_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_lig.png";
import General_14 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_de_gas_emp.png";
import General_15 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/OtherItems/gen_sit_spe_met.png";

import Confined_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_tra_sup.png";
import Confined_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_ris_ass_and_saf_pla.png";
import Confined_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_sur.png";
import Confined_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_deg_emp_cle.png";
import Confined_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_ins_che_cct.png";
import Confined_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_det_mon.png";
import Confined_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_res_pla.png";
import Confined_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_iso.png";
import Confined_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_two_way_rad.jpg";
import Confined_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_com_ind.png";
import Confined_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_com.png";
import Confined_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_tri.png";
import Confined_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_res_equ.png";
import Confined_14 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_acc_egr.png";
import Confined_15 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_per_to_wor.png";
import Confined_16 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_tag_on_off.png";
import Confined_17 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/ConfinedSpace/con_spa_sit_spe_met.png";

import Asbestos_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Asbestos/asb_ris_ass_and_saf_pla.png";
import Asbestos_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Asbestos/asb_exa_ins.png";
import Asbestos_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Asbestos/asb_sop.png";
import Asbestos_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Asbestos/asb_sur.png";
import Asbestos_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Asbestos/asb_sur_typ_1.png";
import Asbestos_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Asbestos/asb_sur_typ_2.png";
import Asbestos_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Asbestos/asb_sur_typ_3.png";
import Asbestos_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Asbestos/asb_dus_sup.png";
import Asbestos_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Asbestos/asb_was_rem.png";
import Asbestos_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Asbestos/asb_sit_spe_met.png";

import Substances_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Substances/sub_sto_lab.png";
import Substances_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Substances/sub_saf_dat.png";
import Substances_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Substances/sub_sec_sto.png";
import Substances_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Substances/sub_ris_ass.png";
import Substances_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Substances/sub_cov_cut.png";
import Substances_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Substances/sub_no_eat.png";
import Substances_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Substances/sub_ven.png";
import Substances_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Substances/sub_spr.png";
import Substances_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Substances/sub_lit.png";
import Substances_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Substances/sub_per_to_wor.png";
import Substances_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/Substances/sub_was_han.png";

import WCWL_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_edg_pro.png";
import WCWL_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_fal_arr.png";
import WCWL_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_wor_pla.png";
import WCWL_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_lif_rin.png";
import WCWL_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_saf_lin.png";
import WCWL_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_pro_flo.png";
import WCWL_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_boa.png";
import WCWL_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_cof.png";
import WCWL_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_pon_cra.png";
import WCWL_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_dre.png";
import WCWL_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_div.png";
import WCWL_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/WorkingCloseToWater/wor_clo_to_wat_sit_spe_met.png";

import services_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_sur_map.png";
import services_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_ser_sup.png";
import services_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_dec_mar.png";
import services_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_saf_fil.png";
import services_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_war_sig.png";
import services_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_div_off.png";
import services_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_iso_loc_out.png";
import services_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_tag_on_tag_off.png";
import services_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_gas_bot_sto.png";
import services_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_bar_fen_hoa.png";
import services_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_esb_net_not.png";
import services_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_gas_com_not.png";
import services_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_iri_wat_wat_mai.png";
import services_14 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_iri_wat_fou_sew.png";
import services_15 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_sto_dra.png";
import services_16 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_han_dig.png";
import services_17 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_no_tip.png";
import services_18 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_oh_lin.png";
import services_19 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_saf_tip_are.png";
import services_20 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_per_to_wor.png";
import services_21 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_no_fla.png";
import services_22 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/SewersCulvertsMains/ser_sit_spe_met.png";

import falls_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_ris_ass_and_saf_pla.png";
import falls_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_sop.png";
import falls_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_wor_war.png";
import falls_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_exa_ins.png";
import falls_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_sur.png";
import falls_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_pro.png";
import falls_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_lad.png";
import falls_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_saf_lad.png";
import falls_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_a_lad.png";
import falls_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_roo_lad.png";
import falls_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_tie_lad.png";
import falls_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_tre_pla.png";
import falls_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_mob_sca.png";
import falls_14 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_sca.png";
import falls_15 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_wor_pla.png";
import falls_16 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_she_fan.png";
import falls_17 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_cra_boa.png";
import falls_18 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_chu.png";
import falls_19 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_edg_pro.png";
import falls_20 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_bar_fen_hoa.png";
import falls_21 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_ope_hol.png";
import falls_22 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_sta_pro.png";
import falls_23 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_oh_wor.png";
import falls_24 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_exc_zon.png";
import falls_25 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_sec_sto.png";
import falls_26 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_loa_bay.png";
import falls_27 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_mewp.png";
import falls_28 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_goo_per_hoi.png";
import falls_29 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_pal_bal_sec.png";
import falls_30 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_har.png";
import falls_31 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_veh_pla_con.png";
import falls_32 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_blo_cor.png";
import falls_33 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_lif_poi_eye.png";
import falls_34 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_net_bea_bag.png";
import falls_35 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_blo_gra.png";
import falls_36 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_cab_gua.png";
import falls_37 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_mas_cli.png";
import falls_38 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_sti.png";
import falls_39 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/FallsFallingObjects/fal_fal_sit_spe_met.png";

import Demolition_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_str_sur.png";
import Demolition_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_env_ris_ass.png";
import Demolition_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_met_sta.png";
import Demolition_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_lia_per.png";
import Demolition_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_eme_pro.png";
import Demolition_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_flo_con.png";
import Demolition_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_de_gas.png";
import Demolition_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_fir_gas_vap.png";
import Demolition_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_pre_wea_pla.png";
import Demolition_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_for_wor.png";
import Demolition_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_fac_ret_sho.png";
import Demolition_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_mac.png";
import Demolition_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_cra.png";
import Demolition_14 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_by_han.png";
import Demolition_15 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_dri_saw.png";
import Demolition_16 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_imp_ham.png";
import Demolition_17 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_lon_rea.png";
import Demolition_18 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_pol_pus_arm.png";
import Demolition_19 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_gra.png";
import Demolition_20 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_she_pul.png";
import Demolition_21 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_wre_bal.png";
import Demolition_22 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_che_age.png";
import Demolition_23 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_bur.png";
import Demolition_24 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_hot_cut.png";
import Demolition_25 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_the_lan.png";
import Demolition_26 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_rop_dem.png";
import Demolition_27 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_pre_ste.png";
import Demolition_28 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_exp.png";
import Demolition_29 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_pub_exc_zon.png";
import Demolition_30 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_pro.png";
import Demolition_31 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_vib_con.png";
import Demolition_32 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_rem_con.png";
import Demolition_33 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/DemolitionMethod/dem_sit_spe_met.png";

import Bio_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/BiologicalAgents/bio_age_saf_dat.png";
import Bio_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/BiologicalAgents/bio_age_sto_lab.png";
import Bio_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/BiologicalAgents/bio_age_ris_ass_pla_sa.png";
import Bio_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/BiologicalAgents/bio_age_ris_ass_pla_saf.png";
import Bio_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/BiologicalAgents/bio_age_no_eat.png";
import Bio_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/BiologicalAgents/bio_age_ven.png";
import Bio_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/BiologicalAgents/bio_age_lit.png";
import Bio_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/BiologicalAgents/bio_age_was_han.png";
import Bio_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/BiologicalAgents/bio_age_per_to_wor.png";

import Plant_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_360_war_bea.png";
import Plant_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_mir.png";
import Plant_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_rev_war_dev.png";
import Plant_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_rev_cam.png";
import Plant_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_sel_sui.png";
import Plant_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_exa_ins.png";
import Plant_7 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_acc_poi_ste.png";
import Plant_8 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_fir_gro.png";
import Plant_9 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_loa_sta.png";
import Plant_10 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_gua_pto.png";
import Plant_11 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_rol_over_pro.png";
import Plant_12 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_loc_att.png";
import Plant_13 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_saf_cli.png";
import Plant_14 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_for_cla_ext.png";
import Plant_15 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_pum_con.png";
import Plant_16 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_dea_man_han.png";
import Plant_17 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_saf_dri.png";
import Plant_18 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_sea_bel.png";
import Plant_19 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_no_pas.png";
import Plant_20 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_saf_wor_loa.png";
import Plant_21 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_saf_par.png";
import Plant_22 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_pla_lif.png";
import Plant_23 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_sit_spe_con.png";
import Plant_24 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_che_lif_gea.png";
import Plant_25 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_exc_che_val.png";
import Plant_26 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_cra.png";
import Plant_27 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_cra_cor.png";
import Plant_28 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_man_cra.png";
import Plant_29 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_sla_lif_gea.png";
import Plant_30 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_sli_sig.png";
import Plant_31 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_veh_pla_con.png";
import Plant_32 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_2_way_rad.png";
import Plant_33 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_exc_zon.png";
import Plant_34 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_vel_tur.png";
import Plant_35 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_wor_on_foo.png";
import Plant_36 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_del_tra.png";
import Plant_37 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_no_tip.png";
import Plant_38 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_oh_lin.png";
import Plant_39 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_vib_con_ser.png";
import Plant_40 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_dus_muc_cle.png";
import Plant_41 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_vel_mov.png";
import Plant_42 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_vel_rec.png";
import Plant_43 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_tel.png";
import Plant_44 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_gra_lor.png";
import Plant_45 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_blo_gra.png";
import Plant_46 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_rem_con.png";
import Plant_47 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_con_pum.png";
import Plant_48 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_con_ski.png";
import Plant_49 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_wat_bow.png";
import Plant_50 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_gla_suc.png";
import Plant_51 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_ker_mac_pin.png";
import Plant_52 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_roa_pla_pin.png";
import Plant_53 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_roc_bre_cab.png";
import Plant_54 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_cru_pla.png";
import Plant_55 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_gas_bot_sto.png";
import Plant_56 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_cem_mix.png";
import Plant_57 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_sti.png";
import Plant_58 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_ski_bin.png";
import Plant_59 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_gra_cut.png";
import Plant_60 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_str.png";
import Plant_61 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_bur_hot_lan.png";
import Plant_62 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_atv_tra_ppe.png";
import Plant_63 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_gas_cyl_bio.png";
import Plant_64 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_com_pla_sec.png";
import Plant_65 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/PlantAndEquipment/pla_sit_spe_met.png";

import Lone_1 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/LoneWorkingViolence/lon_acc_att.png";
import Lone_2 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/LoneWorkingViolence/lon_com_ala.png";
import Lone_3 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/LoneWorkingViolence/lon_con_per_che.png";
import Lone_4 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/LoneWorkingViolence/lon_lia_per.png";
import Lone_5 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/LoneWorkingViolence/lon_ris_ass_tra.png";
import Lone_6 from "../../pages/MasterSSWPFormCreate/img/sswpIcons/LoneWorkingViolence/lon_sit_spe_met.png";

export default {
    "Covid-19 Measures": [
        {
            icon: cov_bys,
            check: "Before You Start",
            key: "cov_bys",
        },
        {
            icon: cov_wor_org,
            check: "Work Organisation",
            key: "cov_wor_org",
        },
        {
            icon: cov_phy_dis,
            check: "Physical Distancing",
            key: "cov_phy_dis",
        },
        {
            icon: cov_per_hyg,
            check: "Personal Hygene",
            key: "cov_per_hyg",
        },
        {
            icon: cov_wel_arr,
            check: "Welfare Arrangements",
            key: "cov_wel_arr",
        },
        {
            icon: cov_can_arr,
            check: "Canteen Arrangements",
            key: "cov_can_arr",
        },
        {
            icon: cov_eat_on_sit,
            check: "Eating On Site",
            key: "cov_eat_on_sit",
        },
        {
            icon: cov_too_equ_sur,
            check: "Tools, Equipment, Surfaces",
            key: "cov_too_equ_sur",
        },
        {
            icon: cov_veh,
            check: "Vehicles",
            key: "cov_veh",
        },
        {
            icon: cov_sig,
            check: "Signages",
            key: "cov_sig",
        },
        {
            icon: cov_del,
            check: "Deliveries",
            key: "cov_del",
        },
        {
            icon: cov_mee,
            check: "Meeting",
            key: "cov_mee",
        },
        {
            icon: cov_1st_aid,
            check: "1st Aid",
            key: "cov_1st_aid",
        },
        {
            icon: cov_cov_ppe,
            check: "PPE",
            key: "cov_cov_ppe",
        }
    ],
    Supervision: [
        {
            icon: supervision_10,
            check: "Safe Pass",
            key: "sup_saf_pas",
        },
        {
            icon: supervision_8,
            check: "Plant/ EQ Cert",
            key: "sup_pla_equ",
        },
        {
            icon: supervision_3,
            check: "CSCS",
            key: "sup_csc",
        },
        {
            icon: supervision_2,
            check: "Communication/ Induction",
            key: "sup_com_ind",
        },
        {
            icon: supervision_13,
            check: "WC & Washing",
            key: "sup_wc_was",
        },
        {
            icon: supervision_1,
            check: "Canteen",
            key: "sup_can",
        },
        {
            icon: supervision_5,
            check: "Drying/ Changing",
            key: "sup_dry_cha",
        },
        {
            icon: supervision_4,
            check: "Drinking Water",
            key: "sup_dri_wat",
        },
        {
            icon: supervision_6,
            check: "First Aid",
            key: "sup_fir_aid",
        },
        {
            icon: supervision_9,
            check: "PPE",
            key: "sup_ppe",
        },
        {
            icon: supervision_12,
            check: "Smoking Control",
            key: "sup_smo_con",
        },
        {
            icon: supervision_11,
            check: "Site Specific Method Statement",
            key: "sup_sit_spe_met",
        },
    ],
    Traffic: [
        {
            icon: traffic_3,
            check: "< 15 Min",
            key: "tra_15_min",
        },
        {
            icon: traffic_9,
            check: "Hi-Vis Truck/ Fend/ Sign",
            key: "tra_hi_vis_tru",
        },
        {
            icon: traffic_23,
            check: "Visibility",
            key: "tra_15_min",
        },
        {
            icon: traffic_14,
            check: "Parking",
            key: "tra_par",
        },
        {
            icon: traffic_19,
            check: "Standard Plan",
            key: "tra_sta_pla",
        },
        {
            icon: traffic_2,
            check: "2 Way Traffic",
            key: "tra_2_way_tra",
        },
        {
            icon: traffic_7,
            check: "Give & Take",
            key: "tra_giv_tak",
        },
        {
            icon: traffic_15,
            check: "Priority",
            key: "tra_pri",
        },
        {
            icon: traffic_20,
            check: "Stop & Go/ Marshall",
            key: "tra_sto_and_go",
        },
        {
            icon: traffic_21,
            check: "Traffic Signals",
            key: "tra_tra_sig",
        },
        {
            icon: traffic_6,
            check: "All Stop",
            key: "tra_all_sto",
        },
        {
            icon: traffic_16,
            check: "Semi-Stati",
            key: "tra_sem_sta",
        },
        {
            icon: traffic_11,
            check: "Liaison/ Permission",
            key: "tra_lia_per",
        },
        {
            icon: traffic_5,
            check: "Additional Signa",
            key: "tra_add_sig",
        },
        {
            icon: traffic_12,
            check: "Lighting",
            key: "tra_lig",
        },
        {
            icon: traffic_10,
            check: "Impact Protection Vehicle",
            key: "tra_imp_pro_veh",
        },
        {
            icon: traffic_13,
            check: "Mobile Road Works",
            key: "tra_mob_roa",
        },
        {
            icon: traffic_22,
            check: "Vehicle Restraint System",
            key: "tra_veh_res_sys",
        },
        {
            icon: traffic_18,
            check: "Speed Control/ Convoy",
            key: "tra_spe_con_con",
        },
        {
            icon: traffic_17,
            check: "Site Specific Method Statement",
            key: "tra_sit_spe_met",
        },
    ],
    "Working close to public": [
        {
            icon: WCTP_2,
            check: "Barriers/ Fencing/ Hoarding",
            key: "wcp_bar_fen_hoa",
        },
        {
            icon: WCTP_7,
            check: "Housekeeping",
            key: "wcp_hou",
        },
        {
            icon: WCTP_9,
            check: "Pedestrian Routes/ Crossing Point",
            key: "wcp_ped_rou",
        },
        {
            icon: WCTP_3,
            check: "Cycle Lane/ Shared Running Lane",
            key: "wcp_cyc_lan",
        },
        {
            icon: WCTP_8,
            check: "Pedestrian Controller",
            key: "wcp_ped_con",
        },
        {
            icon: WCTP_10,
            check: "Public Transport Point",
            key: "wcp_pub_tra_poi",
        },
        {
            icon: WCTP_1,
            check: "Access To Premises",
            key: "wcp_acc_pre",
        },
        {
            icon: WCTP_4,
            check: "Dust/ Muck/ Cleaning & Removal",
            key: "wcp_dus_muc_cle",
        },
        {
            icon: WCTP_11,
            check: "Security",
            key: "wcp_sec",
        },
        {
            icon: WCTP_13,
            check: "Visitor Control",
            key: "wcp_vis_con",
        },
        {
            icon: WCTP_5,
            check: "Handover Controls",
            key: "wcp_han_con",
        },
        {
            icon: WCTP_12,
            check: "Site Specific Method Statement",
            key: "wcp_sit_spe_met",
        },
    ],
    "Plant and equipment": [
        {
            icon: Plant_1,
            check: "360 Warning Beacons",
            key: "pla_360_war_bea",
        },
        {
            icon: Plant_2,
            check: "Mirrors",
            key: "pla_mir",
        },
        {
            icon: Plant_3,
            check: "Reversing Warning Device",
            key: "pla_rev_war_dev",
        },
        {
            icon: Plant_4,
            check: "Reversing Camera",
            key: "pla_rev_cam",
        },
        {
            icon: Plant_5,
            check: "Selection/ Suitability",
            key: "pla_sel_sui",
        },
        {
            icon: Plant_6,
            check: "Examination & Inspection",
            key: "pla_exa_ins",
        },
        {
            icon: Plant_7,
            check: "Access Points & Steps",
            key: "pla_acc_poi_ste",
        },
        {
            icon: Plant_8,
            check: "Firm Ground",
            key: "pla_fir_gro",
        },
        {
            icon: Plant_9,
            check: "Load Stability",
            key: "pla_loa_sta",
        },
        {
            icon: Plant_10,
            check: "Guards For PTO/ Machinery/ Equipment",
            key: "pla_gua_pto",
        },
        {
            icon: Plant_11,
            check: "Roll Over Protection",
            key: "pla_rol_over_pro",
        },
        {
            icon: Plant_12,
            check: "Locking Attachments",
            key: "pla_loc_att",
        },
        {
            icon: Plant_13,
            check: "Safety Clips",
            key: "pla_saf_cli",
        },
        {
            icon: Plant_14,
            check: "Fork Clamps/ Extension",
            key: "pla_for_cla_ext",
        },
        {
            icon: Plant_15,
            check: "Pump Connections",
            key: "pla_pum_con",
        },
        {
            icon: Plant_16,
            check: "Dead Mans Handle",
            key: "pla_dea_man_han",
        },
        {
            icon: Plant_17,
            check: "Safe Driving",
            key: "pla_saf_dril",
        },
        {
            icon: Plant_18,
            check: "Seat Belts",
            key: "pla_sea_bel",
        },
        {
            icon: Plant_19,
            check: "No Passengers",
            key: "pla_no_pas",
        },
        {
            icon: Plant_20,
            check: "Safe Working Load",
            key: "pla_saf_wor_loa",
        },
        {
            icon: Plant_21,
            check: "Safe Parking",
            key: "pla_saf_par",
        },
        {
            icon: Plant_22,
            check: "Plan Lift",
            key: "pla_pla_lif",
        },
        {
            icon: Plant_23,
            check: "Site Speed Controls",
            key: "pla_sit_spe_con",
        },
        {
            icon: Plant_24,
            check: "Check Lifting Gear",
            key: "pla_che_lif_gea",
        },
        {
            icon: Plant_25,
            check: "Excavator Check Valve",
            key: "pla_exc_che_val",
        },
        {
            icon: Plant_26,
            check: "Crane",
            key: "pla_cra",
        },
        {
            icon: Plant_27,
            check: "Crane Co-Ordination",
            key: "pla_cra_cor",
        },
        {
            icon: Plant_28,
            check: "Man Cradle",
            key: "pla_man_cra",
        },
        {
            icon: Plant_29,
            check: "Slab Lifting Gear",
            key: "pla_sla_lif_gea",
        },
        {
            icon: Plant_30,
            check: "Slinger/ Signaller",
            key: "pla_sli_sig",
        },
        {
            icon: Plant_31,
            check: "Vehicle/ Plant Controller",
            key: "pla_veh_pla_con",
        },
        {
            icon: Plant_32,
            check: "2-Way Radios",
            key: "pla_2_way_rad",
        },
        {
            icon: Plant_33,
            check: "Exclusion Zone",
            key: "pla_exc_zon",
        },
        {
            icon: Plant_34,
            check: "Vehicle Turning/ Reversing Area",
            key: "pla_vel_tur",
        },
        {
            icon: Plant_35,
            check: "Workers On Foot Route",
            key: "pla_wor_on_foo",
        },
        {
            icon: Plant_36,
            check: "Delivery/ Transport",
            key: "pla_del_tra",
        },
        {
            icon: Plant_37,
            check: "No Tipping",
            key: "pla_no_tip",
        },
        {
            icon: Plant_38,
            check: "Over Head Lines",
            key: "pla_oh_lin",
        },
        {
            icon: Plant_39,
            check: "Vibration Controls/ Service Duration",
            key: "pla_vib_con_ser",
        },
        {
            icon: Plant_40,
            check: "Dust/ Muck/ Cleaning & Removal",
            key: "pla_dus_muc_cle",
        },
        {
            icon: Plant_41,
            check: "Vehicle Movement",
            key: "pla_vel_mov",
        },
        {
            icon: Plant_42,
            check: "Vehicle Recovery",
            key: "pla_vel_rec",
        },
        {
            icon: Plant_43,
            check: "Teleporter",
            key: "pla_tel",
        },
        {
            icon: Plant_44,
            check: "Grab Lorry",
            key: "pla_gra_lor",
        },
        {
            icon: Plant_45,
            check: "Block Grab and Net",
            key: "pla_blo_gra",
        },
        {
            icon: Plant_46,
            check: "Remote Control",
            key: "pla_rem_con",
        },
        {
            icon: Plant_47,
            check: "Concrete Pump",
            key: "pla_con_pum",
        },
        {
            icon: Plant_48,
            check: "Concrete Skips",
            key: "pla_con_ski",
        },
        {
            icon: Plant_49,
            check: "Water Bowser",
            key: "pla_wat_bow",
        },
        {
            icon: Plant_50,
            check: "Glazing/ Suction",
            key: "pla_gla_suc",
        },
        {
            icon: Plant_51,
            check: "Kerbing Machine/ Pinch/ Fall Controls",
            key: "pla_ker_mac_pin",
        },
        {
            icon: Plant_52,
            check: "Road Planer/ Pinch/ Fall Controls",
            key: "pla_roa_pla_pin",
        },
        {
            icon: Plant_53,
            check: "Rock Breaker/ Cab Protection",
            key: "pla_roc_bre_cab",
        },
        {
            icon: Plant_54,
            check: "Crushing Plant",
            key: "pla_cru_pla",
        },
        {
            icon: Plant_55,
            check: "Gas Bottle Storage",
            key: "pla_gas_bot_sto",
        },
        {
            icon: Plant_56,
            check: "Cement Mixer",
            key: "pla_cem_mix",
        },
        {
            icon: Plant_57,
            check: "Stillages",
            key: "pla_sti",
        },
        {
            icon: Plant_58,
            check: "Skips/ Bins",
            key: "pla_ski_bin",
        },
        {
            icon: Plant_59,
            check: "Grass Cuttings",
            key: "pla_gra_cut",
        },
        {
            icon: Plant_60,
            check: "Strimming",
            key: "pla_str",
        },
        {
            icon: Plant_61,
            check: "Burner/ Hot Air Lance/ PPE Training",
            key: "pla_bur_hot_lan",
        },
        {
            icon: Plant_62,
            check: "ATV/ Training/ PPE",
            key: "pla_atv_tra_ppe",
        },
        {
            icon: Plant_63,
            check: "Gas Cylinder/ Boiler Servicing/ Training",
            key: "pla_gas_cyl_bio",
        },
        {
            icon: Plant_64,
            check: "Compound/ Plant Security",
            key: "pla_com_pla_sec",
        },
        {
            icon: Plant_65,
            check: "Site Specific Method Statement",
            key: "pla_sit_spe_met",
        },
    ],
    "Hand Tools": [
        {
            icon: HTHL_1,
            check: "Cable Check",
            key: "han_cab_che",
        },
        {
            icon: HTHL_20,
            check: "Selection/ Suitability",
            key: "han_sel_sui",
        },
        {
            icon: HTHL_22,
            check: "Voltage",
            key: "han_vol",
        },
        {
            icon: HTHL_9,
            check: "Guards",
            key: "han_gar",
        },
        {
            icon: HTHL_2,
            check: "Cable Protection",
            key: "han_cab_pro",
        },
        {
            icon: HTHL_14,
            check: "Maintenance",
            key: "han_mai",
        },
        {
            icon: HTHL_18,
            check: "Replace Damaged Parts",
            key: "han_rep_dam_par",
        },
        {
            icon: HTHL_11,
            check: "Generators Outside",
            key: "han_gen_out",
        },
        {
            icon: HTHL_7,
            check: "Dust Suppression",
            key: "han_dus_sup",
        },
        {
            icon: HTHL_6,
            check: "Con Saw/ Angle Grinder/ Abrasive Wheels",
            key: "han_con_saw",
        },
        {
            icon: HTHL_4,
            check: "Chainsaw/ Training/ PPE",
            key: "han_cha_saw_ppe",
        },
        {
            icon: HTHL_8,
            check: "Welder/ Flame Cutter",
            key: "han_fla_cut",
        },
        {
            icon: HTHL_17,
            check: "Power Floating",
            key: "han_pow_flo",
        },
        {
            icon: HTHL_14,
            check: "Maintenance",
            key: "han_mai",
        },
        {
            icon: HTHL_13,
            check: "Jack Hammer Vibration Controls",
            key: "han_jac_ham_vib",
        },
        {
            icon: HTHL_3,
            check: "Cartridge Tools",
            key: "han_car_too",
        },
        {
            icon: HTHL_15,
            check: "Paint Sprayer",
            key: "han_pai_spr",
        },
        {
            icon: HTHL_19,
            check: "Sander",
            key: "han_san",
        },
        {
            icon: HTHL_5,
            check: "Compressor & Whip Check",
            key: "han_com_whi_che",
        },
        {
            icon: HTHL_10,
            check: "Gas/ Flame Arrester",
            key: "han_gas_fla_arr",
        },
        {
            icon: HTHL_16,
            check: "Permit to Work",
            key: "han_per_work",
        },
        {
            icon: HTHL_21,
            check: "Site Specific Method Statement",
            key: "han_sit_spe_met",
        },
    ],
    Excavation: [
        {
            icon: EHL_1,
            check: "Examination & Inspection",
            key: "exc_exa_ins",
        },
        {
            icon: EHL_2,
            check: "Firm Ground",
            key: "exc_fir_gro",
        },
        {
            icon: EHL_3,
            check: "Environmental Risk Assess",
            key: "exc_env_ris_ass",
        },
        {
            icon: EHL_4,
            check: "No Undermining",
            key: "exc_no_und",
        },
        {
            icon: EHL_5,
            check: "Back Fill",
            key: "exc_bac_fil",
        },
        {
            icon: EHL_6,
            check: "Batter Back",
            key: "exc_bat_bac",
        },
        {
            icon: EHL_7,
            check: "Propping",
            key: "exc_pro",
        },
        {
            icon: EHL_8,
            check: "Shoring",
            key: "exc_sho",
        },
        {
            icon: EHL_9,
            check: "Trench Box",
            key: "exc_tre_box",
        },
        {
            icon: EHL_10,
            check: "Sheet Piling",
            key: "exc_she_pil",
        },
        {
            icon: EHL_11,
            check: "Ground Frame - Secured",
            key: "exc_gro_fra_sec",
        },
        {
            icon: EHL_12,
            check: "Underpinning",
            key: "exc_und",
        },
        {
            icon: EHL_13,
            check: "Barriers/ Fencing/ Hoarding",
            key: "exc_bar_fen_hoa",
        },
        {
            icon: EHL_14,
            check: "Covers",
            key: "exc_cov",
        },
        {
            icon: EHL_15,
            check: "Spoil Back",
            key: "exc_spo_bac",
        },
        {
            icon: EHL_16,
            check: "Exclusion Zone",
            key: "exc_exc_zon",
        },
        {
            icon: EHL_17,
            check: "Chock",
            key: "exc_cho",
        },
        {
            icon: EHL_18,
            check: "Ladder Access/Egress",
            key: "exc_lad_acc",
        },
        {
            icon: EHL_19,
            check: "Safe Stacking",
            key: "exc_saf_sta",
        },
        {
            icon: EHL_20,
            check: "Pumping",
            key: "exc_pum",
        },
        {
            icon: EHL_21,
            check: "Lighting",
            key: "exc_lig",
        },
        {
            icon: EHL_22,
            check: "Permit To Work",
            key: "exc_per_wor",
        },
        {
            icon: EHL_23,
            check: "Site Specific Method Statement",
            key: "exc_sit_spe_met",
        },
    ],
    "Falls & Falling Objects": [
        {
            icon: falls_1,
            check: "Risk Assess & Plan Safe Method",
            key: "fal_fal_ris_ass_and_saf_pla",
        },
        {
            icon: falls_2,
            check: "SOP",
            key: "fal_fal_sop",
        },
        {
            icon: falls_3,
            check: "Warning Signs",
            key: "fal_fal_wor_war",
        },
        {
            icon: falls_4,
            check: "Examination/ Inspection",
            key: "fal_fal_exa_ins",
        },
        {
            icon: falls_5,
            check: "Surveying",
            key: "fal_fal_sur",
        },
        {
            icon: falls_6,
            check: "Propping",
            key: "fal_fal_pro",
        },
        {
            icon: falls_7,
            check: "Ladder",
            key: "fal_fal_lad",
        },
        {
            icon: falls_8,
            check: "Safe Ladder",
            key: "fal_fal_saf_lad",
        },
        {
            icon: falls_9,
            check: "A Ladder",
            key: "fal_fal_a_lad",
        },
        {
            icon: falls_10,
            check: "Roof Ladder",
            key: "fal_fal_roo_lad",
        },
        {
            icon: falls_11,
            check: "Tie Ladder",
            key: "fal_fal_tie_lad",
        },
        {
            icon: falls_12,
            check: "Trestle Platform",
            key: "fal_fal_tre_pla",
        },
        {
            icon: falls_13,
            check: "Mobile Scaffolding",
            key: "fal_fal_mob_sca",
        },
        {
            icon: falls_14,
            check: "Scaffolding",
            key: "fal_fal_sca",
        },
        {
            icon: falls_15,
            check: "Working Platform",
            key: "fal_fal_wor_pla",
        },
        {
            icon: falls_16,
            check: "Sheeting Fans",
            key: "fal_fal_she_fan",
        },
        {
            icon: falls_17,
            check: "Crawling Boards",
            key: "fal_fal_cra_boa",
        },
        {
            icon: falls_18,
            check: "Chutes",
            key: "fal_fal_chu",
        },
        {
            icon: falls_19,
            check: "Edge Protection",
            key: "fal_fal_edg_pro",
        },
        {
            icon: falls_20,
            check: "Barriers/ Fencing/ Hoarding",
            key: "fal_fal_bar_fen_hoa",
        },
        {
            icon: falls_21,
            check: "Open Holes/ Openings",
            key: "fal_fal_ope_hol",
        },
        {
            icon: falls_22,
            check: "Stair Protection",
            key: "fal_fal_sta_pro",
        },
        {
            icon: falls_23,
            check: "Overhead Work",
            key: "fal_fal_oh_wor",
        },
        {
            icon: falls_24,
            check: "Exclusion Zone",
            key: "fal_fal_exc_zon",
        },
        {
            icon: falls_25,
            check: "Safe Storage",
            key: "fal_fal_sec_sto",
        },
        {
            icon: falls_26,
            check: "Loading Bay",
            key: "fal_fal_loa_bay",
        },
        {
            icon: falls_27,
            check: "MEWP",
            key: "fal_fal_mewp",
        },
        {
            icon: falls_28,
            check: "Goods/ Person Hoist",
            key: "fal_fal_goo_per_hoi",
        },
        {
            icon: falls_29,
            check: "Ballets/ Bales/ Secure Loads",
            key: "fal_fal_pal_bal_sec",
        },
        {
            icon: falls_30,
            check: "Harness",
            key: "fal_fal_har",
        },
        {
            icon: falls_31,
            check: "Vehicle Plant Controller",
            key: "fal_fal_veh_pla_con",
        },
        {
            icon: falls_32,
            check: "Blockwork Courses",
            key: "fal_fal_blo_cor",
        },
        {
            icon: falls_33,
            check: "Lifting Points/ Eyes",
            key: "fal_fal_lif_poi_eye",
        },
        {
            icon: falls_34,
            check: "Nets/ Bean Bags",
            key: "fal_fal_net_bea_bag",
        },
        {
            icon: falls_35,
            check: "Block Grabs & Nets",
            key: "fal_fal_blo_gra",
        },
        {
            icon: falls_36,
            check: "Cab Guards/ FOPs",
            key: "fal_fal_cab_gua",
        },
        {
            icon: falls_37,
            check: "Mast Climber",
            key: "fal_fal_mas_cli",
        },
        {
            icon: falls_38,
            check: "Stilts",
            key: "fal_fal_sti",
        },
        {
            icon: falls_39,
            check: "Site Specific Method Statement",
            key: "fal_fal_sit_spe_met",
        },
    ],
    Services: [
        {
            icon: services_1,
            check: "Survey Map",
            key: "ser_sur_map",
        },
        {
            icon: services_2,
            check: "Service Supplier",
            key: "ser_ser_sup",
        },
        {
            icon: services_3,
            check: "Detect & Mark",
            key: "ser_dec_mar",
        },
        {
            icon: services_4,
            check: "Safety File/ O+M Manual",
            key: "ser_saf_fil",
        },
        {
            icon: services_5,
            check: "Warning Signs",
            key: "ser_war_sig",
        },
        {
            icon: services_6,
            check: "Divert/ Off",
            key: "ser_div_off",
        },
        {
            icon: services_7,
            check: "Isolate/ Lock Out",
            key: "ser_iso_loc_out",
        },
        {
            icon: services_8,
            check: "Tagon/ Tagoff",
            key: "ser_tag_on_tag_off",
        },
        {
            icon: services_9,
            check: "Gas Bottle Storage",
            key: "ser_gas_bot_sto",
        },
        {
            icon: services_10,
            check: "Barriers/ Fencing/ Hoarding",
            key: "ser_bar_fen_hoa",
        },
        {
            icon: services_11,
            check: "ESB Networks",
            key: "ser_esb_net_not",
        },
        {
            icon: services_12,
            check: "Gas Company Notification",
            key: "ser_gas_com_not",
        },
        {
            icon: services_13,
            check: "Irish Water - Main",
            key: "ser_iri_wat_wat_mai",
        },
        {
            icon: services_14,
            check: "Irish Water - Foul Sewer",
            key: "ser_iri_wat_fou_sew",
        },
        {
            icon: services_15,
            check: "Culvert/ Storm Drain",
            key: "ser_sto_dra",
        },
        {
            icon: services_16,
            check: "Hand Dig",
            key: "ser_han_dig",
        },
        {
            icon: services_17,
            check: "No Tipping",
            key: "ser_no_tip",
        },
        {
            icon: services_18,
            check: "Over Head Lines",
            key: "ser_oh_lin",
        },
        {
            icon: services_19,
            check: "Safe Tipping Area",
            key: "ser_saf_tip_are",
        },
        {
            icon: services_20,
            check: "Permit To Work",
            key: "ser_per_to_wor",
        },
        {
            icon: services_21,
            check: "No Flames",
            key: "ser_no_fla",
        },
        {
            icon: services_22,
            check: "Site Specific Method Statement",
            key: "ser_sit_spe_met",
        },
    ],
    "Working Close To Water": [
        {
            icon: WCWL_1,
            check: "Edge Protection",
            key: "wor_clo_to_wat_edg_pro",
        },
        {
            icon: WCWL_2,
            check: "Fall Arrest & Rescue",
            key: "wor_clo_to_wat_fal_arr",
        },
        {
            icon: WCWL_3,
            check: "Working Platform",
            key: "wor_clo_to_wat_wor_pla",
        },
        {
            icon: WCWL_4,
            check: "Life Ring",
            key: "wor_clo_to_wat_lif_rin",
        },
        {
            icon: WCWL_5,
            check: "Safety Line/ Grab Line",
            key: "wor_clo_to_wat_saf_lin",
        },
        {
            icon: WCWL_6,
            check: "Personal Floatation Vest",
            key: "wor_clo_to_wat_per_flo",
        },
        {
            icon: WCWL_7,
            check: "Boat",
            key: "wor_clo_to_wat_boa",
        },
        {
            icon: WCWL_8,
            check: "Coffer Dam",
            key: "wor_clo_to_wat_cof",
        },
        {
            icon: WCWL_9,
            check: "Pontoon & Crane",
            key: "wor_clo_to_wat_edg_pro",
        },
        {
            icon: WCWL_10,
            check: "Dredger",
            key: "wor_clo_to_wat_dre",
        },
        {
            icon: WCWL_11,
            check: "Diving",
            key: "wor_clo_to_wat_div",
        },
        {
            icon: WCWL_12,
            check: "Site Specific Method Statement",
            key: "wor_clo_to_wat_sit_spe_met",
        },
    ],
    Substances: [
        {
            icon: Substances_1,
            check: "Labels",
            key: "sub_sto_lab",
        },
        {
            icon: Substances_2,
            check: "Safety Data Sheet",
            key: "sub_saf_dat",
        },
        {
            icon: Substances_3,
            check: "Secure Storage/ Approved Containers",
            key: "sub_sec_sto",
        },
        {
            icon: Substances_4,
            check: "Risk Assess/ Plan Safe Method",
            key: "sub_ris_ass",
        },
        {
            icon: Substances_5,
            check: "Cover Cuts",
            key: "sub_cov_cut",
        },
        {
            icon: Substances_6,
            check: "No Eating",
            key: "sub_no_eat",
        },
        {
            icon: Substances_7,
            check: "Ventilation",
            key: "sub_ven",
        },
        {
            icon: Substances_8,
            check: "Spraying",
            key: "sub_spr",
        },
        {
            icon: Substances_9,
            check: "Litter Picker",
            key: "sub_lit",
        },
        {
            icon: Substances_10,
            check: "Permit To Work",
            key: "sub_per_to_wor",
        },
        {
            icon: Substances_11,
            check: "Wash Hands",
            key: "sub_was_han",
        },
    ],
    "Biological Agents": [
        {
            icon: Bio_1,
            check: "Safety Data Sheet",
            key: "bio_age_saf_dat",
        },
        {
            icon: Bio_2,
            check: "Storage/ Labels",
            key: "bio_age_sto_lab",
        },
        {
            icon: Bio_3,
            check: "Risk Assess & Plan Safe Method",
            key: "bio_age_ris_ass_pla_saf",
        },
        {
            icon: Bio_4,
            check: "Cover Cuts",
            key: "bio_age_cov_cut",
        },
        {
            icon: Bio_5,
            check: "No Eating",
            key: "bio_age_no_eat",
        },
        {
            icon: Bio_6,
            check: "Ventilation",
            key: "bio_age_ven",
        },
        {
            icon: Bio_7,
            check: "Litter Picker",
            key: "bio_age_lit",
        },
        {
            icon: Bio_8,
            check: "Wash Hands",
            key: "bio_age_was_han",
        },
        {
            icon: Bio_9,
            check: "Permit To Work",
            key: "bio_age_per_to_wor",
        },
    ],
    Asbestos: [
        {
            icon: Asbestos_1,
            check: "Risk Assess & Plan Safe Method",
            key: "asb_ris_ass_and_saf_pla",
        },
        {
            icon: Asbestos_2,
            check: "Examination/ Inspection",
            key: "asb_exa_ins",
        },
        {
            icon: Asbestos_3,
            check: "SOP",
            key: "asb_sop",
        },
        {
            icon: Asbestos_4,
            check: "Surveying",
            key: "asb_sur",
        },
        {
            icon: Asbestos_5,
            check: "Surveying - Type 1 (Drawings)",
            key: "asb_sur_typ_1",
        },
        {
            icon: Asbestos_6,
            check: "Surveying - Type 2 (Inspect)",
            key: "asb_sur_typ_2",
        },
        {
            icon: Asbestos_7,
            check: "Surveying - Type 3 (Test)",
            key: "asb_sur_typ_3",
        },
        {
            icon: Asbestos_8,
            check: "Dust Supression",
            key: "asb_dus_sup",
        },
        {
            icon: Asbestos_9,
            check: "Waste Removal",
            key: "asb_was_rem",
        },
        {
            icon: Asbestos_10,
            check: "Site Specific Method Statement",
            key: "asb_sit_spe_met",
        },
    ],
    "Confined Space": [
        {
            icon: Confined_1,
            check: "Training/ Supervision/ Suitability",
            key: "con_spa_tra_sup",
        },
        {
            icon: Confined_2,
            check: "Risk Assess & Safety Plan Method",
            key: "con_spa_ris_ass_and_saf_pla",
        },
        {
            icon: Confined_3,
            check: "Survey",
            key: "con_spa_sur",
        },
        {
            icon: Confined_4,
            check: "De-Gas/ Empty/ Clean",
            key: "con_spa_deg_emp_cle",
        },
        {
            icon: Confined_5,
            check: "Inspection/ Check/ CCTV",
            key: "con_spa_ins_che_cct",
        },
        {
            icon: Confined_6,
            check: "Detect/ Monitor",
            key: "con_spa_det_mon",
        },
        {
            icon: Confined_7,
            check: "Rescue Plan",
            key: "con_spa_res_pla",
        },
        {
            icon: Confined_8,
            check: "Isolate/ Lock Out",
            key: "con_spa_iso",
        },
        {
            icon: Confined_9,
            check: "2 Way Radios",
            key: "con_spa_two_way_rad",
        },
        {
            icon: Confined_10,
            check: "Communication/ Induction",
            key: "con_spa_com_ind",
        },
        {
            icon: Confined_11,
            check: "Communication Control",
            key: "con_spa_com_con",
        },
        {
            icon: Confined_12,
            check: "Tripod",
            key: "con_spa_tri",
        },
        {
            icon: Confined_13,
            check: "Respiratory Protective Equipment",
            key: "con_spa_res_equ",
        },
        {
            icon: Confined_14,
            check: "Access/ Egress",
            key: "con_spa_acc_egr",
        },
        {
            icon: Confined_15,
            check: "Permit To Work",
            key: "con_spa_per_to_wor",
        },
        {
            icon: Confined_16,
            check: "Tagon/ Tagoff",
            key: "con_spa_tag_on_off",
        },
        {
            icon: Confined_17,
            check: "Site Specific Method Statement",
            key: "con_spa_sit_spe_met",
        },
    ],
    Infestation: [
        {
            icon: Infestation_1,
            check: "Surveying",
            key: "inf_sur",
        },
        {
            icon: Infestation_2,
            check: "Weil's Disease/ Hygiene",
            key: "inf_wei_dis",
        },
        {
            icon: Infestation_3,
            check: "Decontamination/ Extermination",
            key: "inf_dec_ext",
        },
        {
            icon: Infestation_4,
            check: "Specialist PPE",
            key: "inf_spe_ppe",
        },
        {
            icon: Infestation_5,
            check: "Site Specific Method Statement",
            key: "inf_spe_sit_spe_met",
        },
    ],
    Dusting: [
        {
            icon: Dust_1,
            check: "Ventilation",
            key: "dus_ven",
        },
        {
            icon: Dust_2,
            check: "Wetting",
            key: "dus_wet",
        },
        {
            icon: Dust_3,
            check: "Extraction",
            key: "dus_ext",
        },
        {
            icon: Dust_4,
            check: "Site Specific Method Statement",
            key: "dus_sit_spe_met",
        },
    ],
    "Lone Working Violence": [
        {
            icon: Lone_1,
            check: "",
            key: "lon_acc_att",
        },
        {
            icon: Lone_2,
            check: "",
            key: "lon_com_ala",
        },
        {
            icon: Lone_3,
            check: "",
            key: "lon_con_per_che",
        },
        {
            icon: Lone_4,
            check: "",
            key: "lon_lia_per",
        },
        {
            icon: Lone_5,
            check: "",
            key: "lon_ris_ass_tra",
        },
        {
            icon: Lone_6,
            check: "",
            key: "lon_sit_spe_met",
        },
    ],
    Fire: [
        {
            icon: fire_1,
            check: "Extinguisher - Dry Powder (Most Fires, Electrics)",
            key: "fir_ext_dry_pow",
        },
        {
            icon: fire_2,
            check: "Extinguisher - Water (Cloth, Paper, Wood)",
            key: "fir_ext_wat",
        },
        {
            icon: fire_3,
            check: "Extinguisher - Foam (Oil, Fuel only)",
            key: "fir_ext_foa",
        },
        {
            icon: fire_4,
            check: "Extinguisher - Carbon Dioxide (Flammable Liquid, Electric)",
            key: "fir_ext_car_dio",
        },
        {
            icon: fire_5,
            check: "Emergency Route",
            key: "fir_eme_rou",
        },
        {
            icon: fire_6,
            check: "Site Specific Method Statement",
            key: "fir_sit_spe_met",
        },
    ],
    "Harmful Gases": [
        {
            icon: HGHL_1,
            check: "Survey",
            key: "ham_gas_sur",
        },
        {
            icon: HGHL_2,
            check: "Ventilation",
            key: "ham_gas_ven",
        },
        {
            icon: HGHL_3,
            check: "Permit To Work",
            key: "ham_gas_per_wor",
        },
        {
            icon: HGHL_4,
            check: "Site Specific Method Statement",
            key: "ham_gas_sit_spe_met",
        },
    ],
    "In-Situ": [
        {
            icon: IHL_1,
            check: "Open Holes/ Openings",
            key: "insitu_gua_all_ope",
        },
        {
            icon: IHL_2,
            check: "Propping",
            key: "insitu_pro_sup",
        },
        {
            icon: IHL_3,
            check: "Proprietary Edge Protection",
            key: "insitu_pro_edg_pro",
        },
        {
            icon: IHL_4,
            check: "Proprietary Work Platform",
            key: "insitu_pro_wor_pla",
        },
        {
            icon: IHL_5,
            check: "Temporary Works",
            key: "insitu_tem_wor",
        },
        {
            icon: IHL_6,
            check: "Form Tables",
            key: "insitu_for_tab",
        },
        {
            icon: IHL_7,
            check: "Concrete Poker",
            key: "insitu_con_pok",
        },
        {
            icon: IHL_8,
            check: "Rebar",
            key: "insitu_reb",
        },
        {
            icon: IHL_9,
            check: "Steel Fixings",
            key: "insitu_ste_fix",
        },
        {
            icon: IHL_10,
            check: "Concrete Pour",
            key: "insitu_con_pou",
        },
        {
            icon: IHL_11,
            check: "Strikings",
            key: "insitu_str",
        },
        {
            icon: IHL_12,
            check: "Site Specific Method Statement",
            key: "insitu_sit_spe_met",
        },
    ],
    "Pre-Cast": [
        {
            icon: PHL_1,
            check: "Delivery/ Transport",
            key: "pre_cast_del_tra",
        },
        {
            icon: PHL_2,
            check: "Anchors/ Clutches",
            key: "pre_cast_anc_clu",
        },
        {
            icon: PHL_3,
            check: "Spreader Beams",
            key: "pre_cast_spr_bea",
        },
        {
            icon: PHL_4,
            check: "Packing Pieces",
            key: "pre_cast_pac_pie",
        },
        {
            icon: PHL_5,
            check: "Tag Lines",
            key: "pre_cast_tag_lin",
        },
        {
            icon: PHL_6,
            check: "Exclusion Zone",
            key: "pre_cast_exc_zon",
        },
        {
            icon: PHL_7,
            check: "Fixings & Anchors",
            key: "pre_cast_fix_anc",
        },
        {
            icon: PHL_8,
            check: "Slab Bearings",
            key: "pre_cast_sla_bea",
        },
        {
            icon: PHL_9,
            check: "Propping Type",
            key: "pre_cast_pro_typ",
        },
        {
            icon: PHL_10,
            check: "Site Specific Method Statement",
            key: "pre_cast_sit_spe_met",
        },
    ],
    "Steel Workings": [
        {
            icon: Steel_1,
            check: "Access/ Egress",
            key: "ste_wor_acc",
        },
        {
            icon: Steel_2,
            check: "Fall Arrest & Rescue",
            key: "ste_wor_fal_and_arr",
        },
        {
            icon: Steel_3,
            check: "Safety Line/ Grab Line",
            key: "ste_wor_saf_lin",
        },
        {
            icon: Steel_4,
            check: "Nets/ Bean Bags",
            key: "ste_wor_net_bea_bag",
        },
    ],
    "Ground Floor": [
        {
            icon: groundfloor_1,
            check: "Access and Egress",
            key: "gro_flo_acc_egr",
        },
        {
            icon: groundfloor_2,
            check: "Firm Ground",
            key: "gro_flo_fir_gro",
        },

        {
            icon: groundfloor_4,
            check: "Housekeeping",
            key: "gro_flo_hou",
        },
        {
            icon: groundfloor_5,
            check: "Rebar",
            key: "gro_flo_reb",
        },
        {
            icon: groundfloor_6,
            check: "Scaffold",
            key: "gro_flo_sca",
        },
        {
            icon: groundfloor_7,
            check: "Site Specific Method Statement",
            key: "gro_flo_sit_spe_met",
        },
        {
            icon: groundfloor_8,
            check: "Trestle Platform",
            key: "gro_flo_tre",
        },
        {
            icon: groundfloor_9,
            check: "Worker on Foot Route",
            key: "gro_flo_wor_rou",
        },
    ],
    "Upper Floor": [
        {
            icon: UFHL_1,
            check: "Access/ Egress",
            key: "upp_flo_ass_rou",
        },
        {
            icon: UFHL_2,
            check: "Housekeeping",
            key: "upp_flo_hou",
        },
        {
            icon: UFHL_3,
            check: "Worker on Foot Routes",
            key: "upp_flo_wor_foo",
        },
        {
            icon: UFHL_4,
            check: "Ladder Access",
            key: "upp_flo_lad_acc",
        },
        {
            icon: UFHL_5,
            check: "Safe Ladder",
            key: "upp_flo_saf_lad",
        },
        {
            icon: UFHL_6,
            check: "Tie Ladder",
            key: "upp_flo_tie_lad",
        },
        {
            icon: UFHL_7,
            check: "Scaffold",
            key: "upp_flo_sca",
        },
        {
            icon: UFHL_8,
            check: "Edge Protection",
            key: "upp_flo_edg_pro",
        },
        {
            icon: UFHL_9,
            check: "Working Platform",
            key: "upp_flo_wor_pla",
        },
        {
            icon: UFHL_10,
            check: "Stair Protection",
            key: "upp_flo_sta_pro",
        },
        {
            icon: UFHL_11,
            check: "Joist Decking",
            key: "upp_flo_joi_dec",
        },
        {
            icon: UFHL_12,
            check: "Overhead Work",
            key: "upp_flo_oh_wor",
        },
        {
            icon: UFHL_13,
            check: "Fall Arrest and Rescue",
            key: "upp_flo_fal_arr",
        },
        {
            icon: UFHL_14,
            check: "Blockwork Courses",
            key: "upp_flo_blo_cou",
        },
        {
            icon: UFHL_15,
            check: "Exclusion Zone",
            key: "upp_flo_exc_zon",
        },
        {
            icon: UFHL_16,
            check: "Lighting",
            key: "upp_flo_lig",
        },
        {
            icon: UFHL_17,
            check: "Propping Work",
            key: "upp_flo_pro",
        },
        {
            icon: UFHL_18,
            check: "Loading Bay",
            key: "upp_flo_loa_bay",
        },
        {
            icon: UFHL_19,
            check: "Anchors/ Clutches",
            key: "upp_flo_anc_clu",
        },
        {
            icon: UFHL_20,
            check: "Casted Slab Eyes",
            key: "upp_flo_sla_eye",
        },
        {
            icon: UFHL_21,
            check: "Slab Anchors",
            key: "upp_flo_sla_anc",
        },
        {
            icon: UFHL_22,
            check: "Site Specific Method Statement",
            key: "upp_flo_sit_spe_met",
        },
    ],
    "Roof Work & Roof Space": [
        {
            icon: Roof_1,
            check: "Weather",
            key: "roo_wor_wea",
        },
        {
            icon: Roof_2,
            check: "Warning Signs",
            key: "roo_wor_war_sig",
        },
        {
            icon: Roof_3,
            check: "A Ladder",
            key: "roo_wor_a_lad",
        },
        {
            icon: Roof_4,
            check: "Roof Ladders",
            key: "roo_wor_roo_lad",
        },
        {
            icon: Roof_5,
            check: "Edge Protection",
            key: "roo_wor_edg_pro",
        },
        {
            icon: Roof_6,
            check: "Guard All Openings",
            key: "roo_wor_gua_all_ope",
        },
        {
            icon: Roof_7,
            check: "MEWP",
            key: "roo_wor_mew",
        },
        {
            icon: Roof_8,
            check: "Deck Trusses",
            key: "roo_wor_dec_tru",
        },
        {
            icon: Roof_9,
            check: "Nets/Bean Bags",
            key: "roo_wor_net_bea_bag",
        },
        {
            icon: Roof_10,
            check: "Overhead Lines",
            key: "roo_wor_oh_lin",
        },
        {
            icon: Roof_11,
            check: "Stilts",
            key: "roo_wor_saf_sto",
        },
        {
            icon: Roof_12,
            check: "Storage",
            key: "roo_wor_sti",
        },
        {
            icon: Roof_13,
            check: "Site Specific Method Statement",
            key: "roo_wor_sit_spe_met",
        },
    ],
    "Demolition Method": [
        {
            icon: Demolition_1,
            check: "Structural Survey",
            key: "dem_str_sur",
        },
        {
            icon: Demolition_2,
            check: "Environmental Risk Assessment",
            key: "dem_env_ris_ass",
        },
        {
            icon: Demolition_3,
            check: "Method Statement",
            key: "dem_met_sta",
        },
        {
            icon: Demolition_4,
            check: "Liaison/Permission",
            key: "dem_lia_per",
        },
        {
            icon: Demolition_5,
            check: "Emergency Procedures",
            key: "dem_eme_pro",
        },
        {
            icon: Demolition_6,
            check: "Flood Controls",
            key: "dem_flo_con",
        },
        {
            icon: Demolition_7,
            check: "De-Gas/ Empty/ Clean",
            key: "dem_de_gas",
        },
        {
            icon: Demolition_8,
            check: "Fire/ Gas/ Vapour Controls",
            key: "dem_fir_gas_vap",
        },
        {
            icon: Demolition_9,
            check: "Pre Weakening Plan",
            key: "dem_pre_wea_pla",
        },
        {
            icon: Demolition_10,
            check: "Form Work",
            key: "dem_for_wor",
        },
        {
            icon: Demolition_11,
            check: "Facade Retention Shoring",
            key: "dem_fac_ret_sho",
        },
        {
            icon: Demolition_12,
            check: "Machine",
            key: "dem_mac",
        },
        {
            icon: Demolition_13,
            check: "Emergency Procedures",
            key: "dem_cra",
        },
        {
            icon: Demolition_14,
            check: "By Hand",
            key: "dem_by_han",
        },
        {
            icon: Demolition_15,
            check: "Drilling/ Sawing",
            key: "dem_dri_saw",
        },
        {
            icon: Demolition_16,
            check: "Impact Hammer",
            key: "dem_imp_ham",
        },
        {
            icon: Demolition_17,
            check: "Long Reach",
            key: "dem_lon_rea",
        },
        {
            icon: Demolition_18,
            check: "Demolition Pole/ Pusher Arm",
            key: "dem_pol_pus_arm",
        },
        {
            icon: Demolition_19,
            check: "Grapple",
            key: "dem_gra",
        },
        {
            icon: Demolition_20,
            check: "Shears/ Pulverizer",
            key: "dem_she_pul",
        },
        {
            icon: Demolition_21,
            check: "Wrecking Ball",
            key: "dem_wre_ba",
        },
        {
            icon: Demolition_22,
            check: "Chemical Agents",
            key: "dem_che_age",
        },
        {
            icon: Demolition_23,
            check: "Bursting",
            key: "dem_bur",
        },
        {
            icon: Demolition_24,
            check: "Hot Cutting",
            key: "dem_hot_cut",
        },
        {
            icon: Demolition_25,
            check: "Thermic Lancing",
            key: "dem_the_lan",
        },
        {
            icon: Demolition_26,
            check: "Rope Demolition",
            key: "dem_rop_dem",
        },
        {
            icon: Demolition_27,
            check: "Pre Stressed Steel",
            key: "dem_pre_ste",
        },
        {
            icon: Demolition_28,
            check: "Explosives",
            key: "dem_exp",
        },
        {
            icon: Demolition_29,
            check: "Public Exclusion Zone",
            key: "dem_pub_exc_zon",
        },
        {
            icon: Demolition_30,
            check: "Propping",
            key: "dem_pro",
        },
        {
            icon: Demolition_31,
            check: "Vibration Controls/ Service Duration",
            key: "dem_vib_con",
        },
        {
            icon: Demolition_32,
            check: "Remote Control",
            key: "dem_rem_con",
        },
        {
            icon: Demolition_33,
            check: "Site Specific Method Statement",
            key: "dem_sit_spe_met",
        },
    ],
    "Rock Blasting": [
        {
            icon: Rock,
            check: "Site Specific Method Statement",
            key: "roc_bla_sit_spe_met",
        },
    ],
    "General / Other Items": [
        {
            icon: General_1,
            check: "Weather",
            key: "gen_oth_wea",
        },
        {
            icon: General_2,
            check: "Housekeeping",
            key: "gen_oth_hou",
        },
        {
            icon: General_3,
            check: "Sanitizer",
            key: "gen_oth_san",
        },
        {
            icon: General_4,
            check: "Warning Signs",
            key: "gen_war_sig",
        },
        {
            icon: General_5,
            check: "Street Structure Drawings",
            key: "gen_dra_str_str",
        },
        {
            icon: General_6,
            check: "Emergency Procedures",
            key: "gen_emg_pro",
        },
        {
            icon: General_7,
            check: "Fire Control/ Assembly",
            key: "gen_fir_con_ass",
        },
        {
            icon: General_8,
            check: "Firm Ground",
            key: "gen_fir_gro",
        },
        {
            icon: General_9,
            check: "Boilers / Burners / Training Services",
            key: "gen_bio_bur_tra",
        },
        {
            icon: General_10,
            check: "Animal Detterrants",
            key: "gen_ani_det",
        },
        {
            icon: General_11,
            check: "Safe Storage",
            key: "gen_saf_sto",
        },
        {
            icon: General_12,
            check: "Waste Management",
            key: "gen_was_man",
        },
        {
            icon: General_13,
            check: "Lighting",
            key: "gen_lig",
        },
        {
            icon: General_14,
            check: "De-Gassing / Empty / Clean",
            key: "gen_de_gas_emp",
        },
        {
            icon: General_15,
            check: "Site Specific Method Statement",
            key: "gen_sit_spe_met",
        },
    ],
    "Health Assess": [
        {
            icon: HAHL_1,
            check: "Assess Health Effects",
            key: "hea_ass_hea_eff",
        },
        {
            icon: HAHL_2,
            check: "Harmful Gases and Dusts",
            key: "hea_har_gas_dus",
        },
        {
            icon: HAHL_3,
            check: "Biological Agent",
            key: "hea_bio_age",
        },
        {
            icon: HAHL_4,
            check: "Syringes",
            key: "hea_syr",
        },
        {
            icon: HAHL_5,
            check: "Health Monitoring/Surveillance",
            key: "hea_mon_sur",
        },
        {
            icon: HAHL_6,
            check: "Vaccination Programme",
            key: "hea_vac",
        },
        {
            icon: HAHL_7,
            check: "Decontamination Unit",
            key: "hea_dec_uni",
        },
        {
            icon: HAHL_8,
            check: "Site Specific Method Statement/ Design",
            key: "hea_sit_spe_met",
        },
    ],
    "Manual Handling": [
        {
            icon: MHHL_1,
            check: "Training",
            key: "man_han_tra",
        },
        {
            icon: MHHL_2,
            check: "Risk Assess",
            key: "man_han_ris_ass",
        },
        {
            icon: MHHL_3,
            check: "Work Organisation",
            key: "man_han_wor_org",
        },
        {
            icon: MHHL_4,
            check: "Safe Footing / Rough Ground",
            key: "man_han_saf_foo",
        },
        {
            icon: MHHL_5,
            check: "Mechanical Aide",
            key: "man_han_mec_aid",
        },
        {
            icon: MHHL_6,
            check: "Multi-Person Lift",
            key: "man_han_mul_per",
        },
        {
            icon: MHHL_7,
            check: "Site Specific Method Statement",
            key: "man_han_sit_spe_met",
        },
    ],
    PPE: [
        {
            icon: ppe_6,
            check: "Hi-Visibility PPE",
            key: "ppe_hi_vis",
        },
        {
            icon: ppe_11,
            check: "Safety Boot Hi-Vis",
            key: "ppe_saf_boo",
        },
        {
            icon: ppe_14,
            check: "Safety Helmet",
            key: "ppe_saf_hel",
        },
        {
            icon: ppe_3,
            check: "Eye Protection",
            key: "ppe_eye_pro",
        },
        {
            icon: ppe_4,
            check: "Face Protection",
            key: "ppe_fac_pro",
        },
        {
            icon: ppe_2,
            check: "Ear Protection",
            key: "ppe_ear_pro",
        },
        {
            icon: ppe_12,
            check: "Safety Gloves",
            key: "ppe_saf_glo",
        },
        {
            icon: ppe_1,
            check: "Dust Mask",
            key: "ppe_dus_mas",
        },
        {
            icon: ppe_10,
            check: "Respiratory Equipment",
            key: "ppe_res_equ",
        },
        {
            icon: ppe_15,
            check: "Safety Overalls",
            key: "ppe_saf_ove",
        },
        {
            icon: ppe_7,
            check: "Knee Pads",
            key: "ppe_kne_pad",
        },
        {
            icon: ppe_13,
            check: "Safety Harness",
            key: "ppe_saf_har",
        },
        {
            icon: ppe_8,
            check: "Floatation Device/ Life Jacket",
            key: "ppe_per_flo_dev",
        },
        {
            icon: ppe_9,
            check: "Radios/ Communication/ Personal Alarms",
            key: "ppe_rad_con_ala",
        },
    ],
};
